import { Alert, Text } from "@mantine/core";
import { useTranslation } from "react-i18next";

import { WEEKLY_DATA_STALE_HOURS } from "@msc/shared";

import { formatZeitpunkt, istVeraltet } from "../../lib/weekly.js";

/**
 * „Salesforce-Stand: …" bzw. „Jira-Stand: …" plus gelber Hinweis, wenn der
 * Stand zum `bezugszeit`punkt älter als 48 h war. Bezug ist beim offenen
 * Weekly „jetzt", beim abgeschlossenen der Abschlusszeitpunkt — sonst trüge
 * jedes eingefrorene Weekly nach zwei Tagen dauerhaft die Warnung.
 */
export function Datenstand({
  labelKey,
  syncedAt,
  bezugszeit,
}: {
  labelKey: "weekly.metrics.sfAsOf" | "weekly.metrics.jiraAsOf";
  syncedAt: string | null;
  bezugszeit: Date;
}) {
  const { t } = useTranslation();
  return (
    <>
      <Text size="xs" c="dimmed">
        {t(labelKey, { date: formatZeitpunkt(syncedAt) })}
      </Text>
      {istVeraltet(syncedAt, bezugszeit) && (
        <Alert color="yellow" py="xs">
          {t("weekly.metrics.stale", { hours: WEEKLY_DATA_STALE_HOURS })}
        </Alert>
      )}
    </>
  );
}
